"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiMerchantRequirementQuery = void 0;
const class_validator_1 = require("class-validator");
const swagger_1 = require("../../../../swagger-fake");
const billing_core_merchant_requirement_scope_enum_1 = require("../../../../billing-core/billing-core-merchant/types/enums/billing-core-merchant-requirement-scope.enum");
class BillingApiMerchantRequirementQuery {}
__decorate([(0, swagger_1.ApiProperty)({
  description: "Страна",
  pattern: "[A-Z][A-Z]",
  example: "US",
  required: false,
  nullable: true
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsString)(), (0, class_validator_1.Length)(2), __metadata("design:type", String)], BillingApiMerchantRequirementQuery.prototype, "countryCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Наименование формы",
  enum: billing_core_merchant_requirement_scope_enum_1.BillingCoreMerchantRequirementScopeEnum
}), (0, class_validator_1.IsEnum)(billing_core_merchant_requirement_scope_enum_1.BillingCoreMerchantRequirementScopeEnum), __metadata("design:type", String)], BillingApiMerchantRequirementQuery.prototype, "scope", void 0);
exports.BillingApiMerchantRequirementQuery = BillingApiMerchantRequirementQuery;
